import { NavigatePaths, useWelfarePortalNavigate } from 'app/src/shared/hooks'
import { Button, type ButtonPassThroughOptions } from 'primereact/button'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

export function GoToCatalogButton(props?: { pt?: ButtonPassThroughOptions }) {
  const { t } = useTranslation('landing')
  const navigate = useWelfarePortalNavigate()

  return (
    <Button
      pt={props?.pt}
      rounded
      outlined
      label={t('Landing.GoToCatalog.ButtonLabel')}
      className='my-5'
      onClick={navigate.goToCatalog}
    ></Button>
  )
}
export function BackToCatalogButton(props?: { pt?: ButtonPassThroughOptions }) {
  const { t } = useTranslation('landing')
  const navigate = useWelfarePortalNavigate()

  return (
    <Button
      pt={props?.pt}
      rounded
      label={t('Landing.BackToCatalog.ButtonLabel')}
      className='my-5'
      onClick={navigate.goToCatalog}
    ></Button>
  )
}

export function BackToDiscountButton(props?: { pt?: ButtonPassThroughOptions }) {
  const { t } = useTranslation('landing')
  const navigate = useWelfarePortalNavigate()

  return (
    <Button
      pt={props?.pt}
      rounded
      label={t('Landing.BackToDiscount.ButtonLabel')}
      className='my-5'
      onClick={navigate.goToDiscount}
    ></Button>
  )
}

export function CheckCatalogButton(props?: { pt?: ButtonPassThroughOptions }) {
  const { t } = useTranslation('landing')
  const navigate = useWelfarePortalNavigate()
  const { pathname } = useLocation()
  /* Check if we are already in the user account page to avoid showing the button there */
  const isUserAccountPage = useMemo(() => pathname.startsWith(NavigatePaths.UserAccount), [pathname])

  return (
    <>
      {isUserAccountPage ? undefined : (
        <Button
          pt={props?.pt}
          rounded
          label={t('Landing.CheckCatalog.ButtonLabel')}
          className='my-5'
          onClick={navigate.goToCatalog}
        ></Button>
      )}
    </>
  )
}

export function GoToCatalogSearchButton(props?: { pt?: ButtonPassThroughOptions }) {
  const { t } = useTranslation('home')

  return (
    <Button
      label={t('AppBar.GotoCatalogSearch')}
      text
      className='p-0 text-left'
      icon='pi pi-angle-right'
      iconPos='right'
      pt={{ label: { className: 'text-[15px] font-semibold leading-[22px]' }, icon: { className: 'text-[15px]' }, ...props?.pt }}
    />
  )
}
